const typography = {
  fontSize: 14,
  fontFamily: ['"Inter"', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
  h1: {
    fontSize: 36,
    lineHeight: 1.32,
    fontWeight: 700,
  },
  h2: {
    fontSize: 24,
    lineHeight: 1.33,
    fontWeight: 700,
  },
  h4: {
    fontSize: 34,
    lineHeight: 1.23,
    fontWeight: 500,
  },
  h5: {
    fontSize: 24,
    lineHeight: '133.4%',
    fontWeight: 500,
  },
  subtitle1: {
    fontSize: 18,
    lineHeight: 1.33,
    fontWeight: 400,
  },
  subtitle2: {
    fontSize: 14,
    lineHeight: 1.57,
    fontWeight: 400,
  },
  subtitle3: {
    fontSize: 16,
    lineHeight: 1.75,
    fontWeight: 400,
    letterSpacing: '0.6px',
  },
  body1: {
    fontSize: 16,
    lineHeight: 'normal',
    fontWeight: 400,
  },
  body2: {
    fontSize: 14,
    lineHeight: 1.57,
    fontWeight: 400,
  },
  caption: {
    fontSize: 12,
    lineHeight: 1.43,
    fontWeight: 400,
  },
  button: {
    fontSize: 14,
    lineHeight: 1.5,
    fontWeight: 500,
  },
  buttonSmall: {
    fontSize: 13,
    lineHeight: 1.5,
    fontWeight: 500,
  },
  inputText: {
    fontSize: 16,
    lineHeight: 1.5,
    fontWeight: 400,
  },
};

export default typography;
